import Auth from "@/middleware/auth";

export default {
    auth: Auth,
}